<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab title="Scramble Quiz" active>
            <hr />
            <Scramblequiz></Scramblequiz>
          </CTab>
          <CTab title="DFS Quiz">
            <hr />
            <DFSQuiz></DFSQuiz>
          </CTab>
          <CTab title="DFS Prediction Quiz">
            <Prediction></Prediction>
          </CTab>
          <CTab title="DFS Betting">
            <Betting></Betting>
          </CTab>
          
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Scramblequiz from "./scramblequiz.vue";
import DFSQuiz from "./dfsquiz.vue";
import Prediction from "./prediction.vue";
import Betting from "./bettingtabs.vue";

export default {
  components: {
    Scramblequiz,
    DFSQuiz,
    Prediction,
    Betting
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
    };
  },
  watch: {},
  methods: {
    // sendmsg(){}
  },
  created() {},
};
</script>
<style>
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>
